import { show, hide } from '../../../util/show'
import { updateNavigationTopOffsetPropertyOnResize } from '../../../components/navigation_top_offset'
import i18n from '../../../i18n'
import { open } from '../../../components/modal_redesign'
import { asUTCDate, isoStringToDatetime, datetimeToString } from '../../../components/date_picker/date_helpers'

up.compiler('.js-navigation_post_settings', element => {
  const destructorMobile = updateNavigationTopOffsetPropertyOnResize('mobile', element)
  const destructorDesktop = updateNavigationTopOffsetPropertyOnResize('desktop', element)
  return () => {
    destructorMobile()
    destructorDesktop()
  }
})

up.compiler('.js-plans_for_paywall', container => {
  const planCheckboxes = container.querySelectorAll('.js-plan_checkbox')
  const accessSentence = document.querySelector('.js-access__sentence')

  if (accessSentence) {
    window.up.on(container, 'change', () => {
      const allChecked = Array.from(planCheckboxes).every(checkbox => checkbox.checked)

      if (allChecked) {
        accessSentence.textContent = accessSentence.dataset.all
      } else {
        accessSentence.textContent = accessSentence.dataset.some
      }
    })
  }
})

const distributeEmailCheckboxSelector = '.js-post_distribute_as_email_input'
up.compiler(distributeEmailCheckboxSelector, checkbox => {
  // disabling inputs prevents native client-side validations from running
  const toggleDisableOfNestedEmailSendingInputs = checkbox => {
    // only including from and reply to inputs because they're the only ones with validation,
    // and disabling more breaks using FormData on this form which is needed for the post email recipients summary
    const inputContainer = document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_inputs')
    const inputs = Array.from(inputContainer.querySelectorAll('input, select, textarea'))
    inputs.forEach(input => {
      if (checkbox.checked) {
        input.removeAttribute('disabled')
      } else {
        input.setAttribute('disabled', 'disabled')
      }
    })
  }

  toggleDisableOfNestedEmailSendingInputs(checkbox)

  up.on(checkbox, 'change', (event, checkbox) => {
    toggleDisableOfNestedEmailSendingInputs(checkbox)
  })
})

const publishLaterCheckboxSelector = '.js-post_publish_later'
up.compiler(publishLaterCheckboxSelector, el => {
  el.addEventListener('change', ev => {
    if (!ev.target.checked) {
      document.querySelector('#post_publish_at').value = ''
    }
  })
})

const showSenderInputs = () => {
  const senderInputs = document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_inputs')
  const editButton = document.querySelector('.js-backend_post_settings_page__change_email_settings_edit')
  show(senderInputs)
  hide(editButton)
  return senderInputs
}

const hideSenderInputs = () => {
  const senderInputs = document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_inputs')
  const editButton = document.querySelector('.js-backend_post_settings_page__change_email_settings_edit')
  hide(senderInputs)
  show(editButton)
  return senderInputs
}

const formSelector = '.js-post_settings_form'
const fromLocalInputSelector = '.js-post_settings__email_from_local'
const fromInputSelector = '.js-post_settings__email_from'
const replyToLocalInputSelector = '.js-post_settings__email_reply_to_local'
const replyToInputSelector = '.js-post_settings__email_reply_to'
up.compiler('.js-backend_post_settings_page__test_email', function (element) {
  up.on(element, 'click', function (event) {
    const fromLocal = document.querySelector(fromLocalInputSelector)
    const replyToLocal = document.querySelector(replyToLocalInputSelector)

    if (!fromLocal.validity.valid || !replyToLocal.validity.valid) {
      showSenderInputs()

      fromLocal.reportValidity()
      replyToLocal.reportValidity()

      return
    }

    const url = element.dataset.url
    const form = document.querySelector(formSelector)
    const formData = new FormData(form)
    // Phoenix includes in the form a hidden field with the request's method.
    // The original form does a PUT, but here we need a POST, so this data needs to be removed.
    formData.delete('_method')
    const headers = {
      // do not set Content-Type for multipart/form-data so that the browser sets it with a correct boundary
    }

    const options = {
      url,
      params: formData,
      headers,
      method: 'post',
      failTarget: 'flash-alert'
    }

    up.navigate('flash-alert', options)
  })
})

up.compiler('.js-backend_post_settings_page__change_email_settings_apply', function (element) {
  up.on(element, 'click', () => {
    const from = document.querySelector(fromInputSelector)
    const replyTo = document.querySelector(replyToInputSelector)
    const fromLocal = document.querySelector(fromLocalInputSelector)
    const replyToLocal = document.querySelector(replyToLocalInputSelector)

    fromLocal.reportValidity()
    replyToLocal.reportValidity()

    if (fromLocal.validity.valid && replyToLocal.validity.valid) {
      hideSenderInputs()

      from.value = fromLocal.value
      replyTo.value = replyToLocal.value

      document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info_from').innerText =
        fromLocal.value
      document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info_reply_to').innerText =
        replyToLocal.value

      // the clicked button disappears on click so something else has to get focus,
      // otherwise SR users will be brought back to page start.
      document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info__lines').focus()
    }
  })
})

up.compiler('.js-backend_post_settings_page__change_email_settings_cancel', function (element) {
  up.on(element, 'click', () => {
    const from = document.querySelector(fromInputSelector)
    const replyTo = document.querySelector(replyToInputSelector)
    const fromLocal = document.querySelector(fromLocalInputSelector)
    const replyToLocal = document.querySelector(replyToLocalInputSelector)

    hideSenderInputs()

    fromLocal.value = from.value
    removeError(fromLocal)

    replyToLocal.value = replyTo.value
    removeError(replyToLocal)

    // the clicked button disappears on click so something else has to get focus,
    // otherwise SR users will be brought back to page start.
    document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info__lines').focus()
  })
})

up.compiler(fromLocalInputSelector, function (element) {
  up.on(element, 'invalid', function () {
    showSenderInputs()
    addError(element, window.steadyI18n.errors.required)
  })

  up.on(element, 'change', function () {
    removeError(element)
  })
})

up.compiler(replyToLocalInputSelector, function (element) {
  up.on(element, 'invalid', function () {
    showSenderInputs()
    addError(element, window.steadyI18n.errors.invalidEmail)
  })

  up.on(element, 'change', function () {
    removeError(element)
  })
})

up.compiler('.js-backend_post_settings_page__change_email_settings_edit', function (element) {
  up.on(element, 'click', () => {
    const senderInputs = showSenderInputs()
    // the clicked button disappears on click so something else has to get focus,
    // otherwise SR users will be brought back to page start.
    // setTimeout is necessary to give time for the senderInputs to appear on the page first
    setTimeout(() => {
      senderInputs.focus()
    }, 1)
  })

  const invalidInput = document.querySelector(
    '.js-backend_post_settings_page__change_email_settings_sender_inputs *[aria-invalid="true"]'
  )

  // if at least one of the hidden inputs has an error, reveal it
  if (invalidInput) {
    showSenderInputs()
  }
})

up.compiler(fromLocalInputSelector, element => {
  element.addEventListener('invalid', function (event) {
    if (event.target.validity.patternMismatch) {
      event.target.setCustomValidity(element.dataset.patternErrorMessage)
    }
  })

  element.addEventListener('change', function (event) {
    event.target.setCustomValidity('')
  })
})

const membersCheckboxSelector = '.js-send_post_email_to_members'
const singlePlanCheckboxSelector = '.js-plans_for_email .js-plan_checkbox'

up.compiler(membersCheckboxSelector, function (membersCheckbox) {
  const emailPlansCheckboxes = [...document.querySelectorAll(singlePlanCheckboxSelector)]

  const setMembersCheckboxState = () => {
    const checkedPlans = emailPlansCheckboxes.filter(el => el.checked)
    const membersCheckbox = document.querySelector(membersCheckboxSelector)
    const checked = checkedPlans.length > 0
    const indeterminate = checkedPlans.length > 0 && checkedPlans.length !== emailPlansCheckboxes.length
    membersCheckbox.checked = checked
    membersCheckbox.indeterminate = indeterminate
  }

  setMembersCheckboxState()

  const onChange = () => {
    const emailPlansCheckboxes = document.querySelectorAll(singlePlanCheckboxSelector)

    // uncheck all plans when membersCheckbox is unchecked
    emailPlansCheckboxes.forEach(el => {
      el.checked = membersCheckbox.checked
    })
  }

  membersCheckbox.addEventListener('change', onChange)
  emailPlansCheckboxes.forEach(emailPlansCheckbox => {
    emailPlansCheckbox.addEventListener('change', setMembersCheckboxState)
  })

  return () => {
    membersCheckbox.removeEventListener('change', onChange)
    emailPlansCheckboxes.forEach(emailPlansCheckbox =>
      emailPlansCheckbox.removeEventListener('change', setMembersCheckboxState)
    )
  }
})

// inputs on this page need their own calls to setCustomValidity
// and cannot rely on the page-wide calls from assets/js/components/input.js
// because they get validated NOT on submit, but
// on some other button press ("apply" and "send test email")
function addError(input, error) {
  input.setAttribute('aria-invalid', 'true')
  input.setCustomValidity(error)
}

function removeError(input) {
  input.setAttribute('aria-invalid', 'false')
  input.setCustomValidity('')
}

const emailRecipientsSelector = '.js-post_email_recipients'
const sendToSubscribersCheckboxName = 'post[post_email_distribution][send_to_subscribers]'
const sendToMembersCheckboxName = 'post[post_email_distribution][send_to_members]'
const individualPlanCheckboxName = 'post[plans_for_email_ids][]'
up.compiler(emailRecipientsSelector, (element, { eligibleMemberCountPerPlan, eligibleFreeMemberCount }) => {
  const memberCountPerPlanValue = JSON.parse(eligibleMemberCountPerPlan)
  const eligibleFreeMemberCountValue = JSON.parse(eligibleFreeMemberCount)

  const form = document.querySelector(formSelector)

  const countAndDisplayRecipients = () => {
    const formData = new FormData(form)
    const selectedPlans = formData.getAll(individualPlanCheckboxName)
    const memberCount = selectedPlans.reduce((acc, planId) => acc + memberCountPerPlanValue[planId], 0)
    element.dataset.memberCount = memberCount

    const sendToSubscribersValues = formData.getAll(sendToSubscribersCheckboxName)
    const subscriberCount = sendToSubscribersValues.includes('true') ? eligibleFreeMemberCountValue : 0
    element.dataset.subscriberCount = subscriberCount

    const count = i18n.$ngettext(
      'Your post will be sent to %{count} member (%{paying_count} paying, %{free_count} free).',
      'Your post will be sent to %{count} members (%{paying_count} paying, %{free_count} free).',
      memberCount + subscriberCount,
      { count: memberCount + subscriberCount, paying_count: memberCount, free_count: subscriberCount }
    )

    const notice = i18n.$gettext(
      'The number of delivered emails shown on the Posts page may end up lower, for example if an address no longer exists or an inbox is full.'
    )

    element.innerText = `${count} ${notice}`
  }

  countAndDisplayRecipients()

  up.on(form, 'change', event => {
    const target = event.target
    if (
      target.name === sendToSubscribersCheckboxName ||
      target.name === sendToMembersCheckboxName ||
      target.name === individualPlanCheckboxName
    ) {
      countAndDisplayRecipients()
    }
  })
})

const publishModalSelector = '.js-publish_confirm_modal'
const openPublishModalButtonSelector = '.js-open_publish_confirm_modal'
const publishModalTextSelector = '.js-publish_confirm_modal_text'
const publishModalButtonSelector = '.js-publish_confirm_modal_button'
const publishAtInputSelector = '.js-post_publish_at .js-date_picker_iso_date_value'
const svgAnimateSelector = publishModalSelector + ' #feather_rising'
up.compiler(openPublishModalButtonSelector, (button, { emailDistributed }) => {
  const modal = document.querySelector(publishModalSelector)
  const modalText = modal.querySelector(publishModalTextSelector)
  const modalButton = modal.querySelector(publishModalButtonSelector)
  const distributeEmailCheckbox = document.querySelector(distributeEmailCheckboxSelector)
  const publishLaterCheckbox = document.querySelector(publishLaterCheckboxSelector)

  if (emailDistributed === 'false' && modal && modalText && modalButton && distributeEmailCheckbox) {
    up.on(button, 'click', event => {
      if (!distributeEmailCheckbox.checked) {
        return
      }

      const countSpan = document.querySelector(emailRecipientsSelector)
      const memberCount = parseInt(countSpan.dataset.memberCount)
      const subscriberCount = parseInt(countSpan.dataset.subscriberCount)

      const publishAt = document.querySelector(publishAtInputSelector)?.value

      let timing = ''
      let buttonMessage = ''
      if (publishLaterCheckbox && publishLaterCheckbox.checked && publishAt) {
        const date = datetimeToString(asUTCDate(isoStringToDatetime(publishAt)))
        timing = i18n.$pgettext('[This post will be sent] on [11.10.2024 09:00]', 'on %{date}', { date })
        buttonMessage = i18n.$gettext('Schedule')
      } else {
        timing = i18n.$pgettext('[This post will be sent] immediately', 'immediately')
        buttonMessage = i18n.$gettext('Send')
      }

      const message = i18n.$ngettext(
        'This post will be sent to %{count} member (%{paying_count} paying, %{free_count} free) %{immediately_or_on_date}.',
        'This post will be sent to %{count} members (%{paying_count} paying, %{free_count} free) %{immediately_or_on_date}.',
        memberCount + subscriberCount,
        {
          count: memberCount + subscriberCount,
          paying_count: memberCount,
          free_count: subscriberCount,
          immediately_or_on_date: timing
        }
      )

      modalText.innerText = message
      modalButton.innerText = buttonMessage

      // we forcefully reload the SVG because of a bug in Chrome that doesn't trigger
      // all the animations after unpoly updates the form on failure
      const svg = document.querySelector(svgAnimateSelector).closest('svg')
      svg.replaceWith(svg.cloneNode(true))

      const svgAnimate = document.querySelector(svgAnimateSelector)
      svgAnimate.beginElement()
      open(modal)
      event.preventDefault()
    })
  }
})
